import user from "../user/state";

export function setMenus(state, menus) {
  // let tags = [];
  // let filtered_menus = [];
  // let filtered_tags = [];
  // menus.forEach(menu => {
  //   menu.tags.forEach(tag => {
  //     tags.push(tag);
  //     filtered_tags = tags.filter(menu =>
  //       user.current_user.including_tags.includes(menu)
  //     );
  //     if (menu.tags.filter(element => filtered_tags.includes(element)).length > 0) {
  //       filtered_menus.push(menu);
  //     }
  //   });
  // });
  state.menus = menus;
}

export function setMenu(state, menu){
  state.selectedMenu = menu
}

export function menusError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
  state.menus = [];
}
// a.filter(menu => b.includes(menu))

export function setPersonalBankingMenus(state, payload) {
  state.personalBankingMenus = payload;
}
